<template>
  <div>
    <vue-portal to="hrsys-navbar">
      <div class="flex text-2xl font-bold text-center">
        <base-back-button/>
        <base-header-title :title="$t('holidays.details')"/>
      </div>
    </vue-portal>
    <holiday-details-component
      :action="$t(`buttons.${[process]}`)"
      :holiday="holidayData"
      @confirm="doHoliday"/>
  </div>
</template>

<script>
  import HolidayDetailsComponent from "../../components/holidays/HolidayDetailsComponent"
  import Holidays from "../../services/Holidays"

  export default {
    name: 'HolidayDetails',
    components: {
      HolidayDetailsComponent
    },
    data () {
      return {
        holidayData: {},
      }
    },
    methods: {
      doHoliday () {
        this.createHoliday()
      },
      createHoliday () {
        this.$vs.loading();
        Holidays.create(this.holidayData).then(() => {
          this.$notificationService.success(`${this.$t('holidays.holiday')} ${this.$t('notification.successCreate')}`);
          window.history.back();
        }).catch((e) => {
          this.$vs.loading.close();
          this.$notificationService.error(e.message);
        })
      },
    }
  }
</script>

<style scoped>

</style>
